import { defaultTableCellPaddingInline } from '../constants';
export function getColumnWidthByDigitsCount(digitsCount) {
    const paddingInlineWidth = defaultTableCellPaddingInline * 2;
    switch (digitsCount) {
        case 2:
            return 17 + paddingInlineWidth;
        case 3:
            return 26 + paddingInlineWidth;
        case 4:
            return 34 + paddingInlineWidth;
        case 5:
            return 43 + paddingInlineWidth;
        case 6:
            return 51 + paddingInlineWidth;
        case 7:
            return 59 + paddingInlineWidth;
        case 8:
            return 68 + paddingInlineWidth;
        default: {
            const exhaustiveCheck = digitsCount;
            throw new Error(`Unhandled PortionState case: ${exhaustiveCheck}`);
        }
    }
}
